module.exports = __webpack_public_path__ + "static/media/fillstar.abfe1311.svg";